<template>
    <div class="profile-friends">
        <router-link
            :to="{name: 'user', params: {id: friend.id}}"
            class="profile-friend"
            v-for="friend of getFirstFriends"
            :key="friend.id"
            :style="{ backgroundImage: 'url(' + friend.avatar + ')' }"
        ></router-link>
        <router-link
            :to="{name: 'friends'}"
            v-if="friends" class="profile-friends__all">
            {{ friends.length || "Нет" }} друзей
        </router-link>
    </div>
</template>
<script>
export default {
    name: 'ProfileFriends',
    props: {
        friends: {
            type: Array,
            require: true
        }
    },
    computed: {
        getFirstFriends () {
            return this.friends ? this.friends.slice(0, 7) : null;
        },
    }
}
</script>